module.exports = __webpack_public_path__ + "static/img/irole.f7b1f4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/bz/irole.png
// module id = aWtd
// module chunks = 7